export default __webpack_public_path__ + "static/media/automobile.a07e9d2a.svg";